import { any, filter, path } from 'ramda'
import { appUrlRoot, loginWithParams, loginWithSsoUrl } from 'app/constants'

export const formatMonthlyCost = ({ amount, currencyTriple }) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyTriple || 'USD',
  }).format(amount)
}

// Helper function to get property values by a path
const getPropertyValue = (strPath, obj) => path(strPath.split('.'), obj)

export const search = (query, data, searchableKeys) => {
  const lowerQuery = query.toLowerCase()

  // Check if any searchable property contains the query
  const matchesQuery = (obj) =>
    any((key) => {
      const value = getPropertyValue(key, obj)
      if (Array.isArray(value)) {
        return any((v) => String(v).toLowerCase().includes(lowerQuery), value)
      }
      return value && String(value).toLowerCase().includes(lowerQuery)
    }, searchableKeys)

  // Filter data based on matching objects
  return filter(matchesQuery, data)
}
